export const getProductCategory = (breadcrumb = []) => {
  if (!breadcrumb || breadcrumb.length === 0) return ''
  return breadcrumb[breadcrumb.length - 1]?.name?.replace(/\s+/g, '-').toLowerCase()
}
